module.exports = __webpack_public_path__ + "img/InvPerson.2f639b7c.jpg";